module.exports = __webpack_public_path__ + "img/vol05_character_name1_sp.a0d371ba.png";